import {
    createRequestTypes,
    START,
    SUCCESS,
    ERROR,
  } from '@modules/appraisal/actions/global';
  import { makeApiActionCreatorV3 } from '@actions/utils';
  import * as api from '../api/agent';
  
  const namespace = 'APPEALS-AGENT';
  
  export const SEARCH_DOCKET_GROUPS = createRequestTypes(
    `${namespace}/SEARCH_DOCKET_GROUPS`,
  );
  
  export const searchDocketGroups = makeApiActionCreatorV3(
    api.searchDocketGroups,
    SEARCH_DOCKET_GROUPS[START],
    SEARCH_DOCKET_GROUPS[SUCCESS],
    SEARCH_DOCKET_GROUPS[ERROR],
  );

  export const FETCH_SEARCH_RESULTS_CONFIG = createRequestTypes(
    `${namespace}/FETCH_SEARCH_RESULTS_CONFIG`,
  );
  
  export const fetchSearchResultsConfig = makeApiActionCreatorV3(
    api.fetchSearchResultsConfig,
    FETCH_SEARCH_RESULTS_CONFIG[START],
    FETCH_SEARCH_RESULTS_CONFIG[SUCCESS],
    FETCH_SEARCH_RESULTS_CONFIG[ERROR],
  );

export const CHANGE_PAGE = `${namespace}/CHANGE_PAGE`;

export const changePage = page => ({
  type: CHANGE_PAGE,
  payload: page,
});

export const CHANGE_ROWS_PER_PAGE = `${namespace}/CHANGE_ROWS_PER_PAGE`;

export const changeRowsPerPage = rowsPerPage => ({
  type: CHANGE_ROWS_PER_PAGE,
  payload: rowsPerPage,
});

export const CHANGE_SORT_MODEL = `${namespace}/CHANGE_SORT_MODEL`;

export const changeSortModel = sortModel => ({
  type: CHANGE_SORT_MODEL,
  payload: sortModel,
});

export const FETCH_DOCKET_GROUP_APPEALS = createRequestTypes(
  `${namespace}/FETCH_DOCKET_GROUP_APPEALS`,
);

export const fetchDocketGroupAppeals = makeApiActionCreatorV3(
  api.fetchDocketGroupAppeals,
  FETCH_DOCKET_GROUP_APPEALS[START],
  FETCH_DOCKET_GROUP_APPEALS[SUCCESS],
  FETCH_DOCKET_GROUP_APPEALS[ERROR],
);